/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { HideReviewedFilterSchemaBy } from './hideReviewedFilterSchemaBy';
import type { HideReviewedFilterSchemaDecisionsItem } from './hideReviewedFilterSchemaDecisionsItem';
import type { HideReviewedFilterSchemaScope } from './hideReviewedFilterSchemaScope';
import type { HideReviewedFilterSchemaTimeRange } from './hideReviewedFilterSchemaTimeRange';
import type { HideReviewedFilterSchemaTimeUnit } from './hideReviewedFilterSchemaTimeUnit';

export interface HideReviewedFilterSchema {
  scope?: HideReviewedFilterSchemaScope;
  by?: HideReviewedFilterSchemaBy;
  time_range?: HideReviewedFilterSchemaTimeRange;
  time_value?: number | null;
  time_unit?: HideReviewedFilterSchemaTimeUnit;
  /** @minItems 1 */
  decisions?: HideReviewedFilterSchemaDecisionsItem[];
}
